import { render, staticRenderFns } from "./QzBook.vue?vue&type=template&id=72a3f76b&scoped=true&"
import script from "./QzBook.vue?vue&type=script&lang=js&"
export * from "./QzBook.vue?vue&type=script&lang=js&"
import style0 from "./QzBook.vue?vue&type=style&index=0&id=72a3f76b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a3f76b",
  null
  
)

export default component.exports